<div class="modal-header">
    <h5 class="modal-title">Yıllık İzin Hakkı Ekle</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="mb-3">
            <label for="year" class="form-label">Yıl</label>
            <input type="number" id="year" class="form-control" formControlName="year" />
            <div class="text-danger" *ngIf="form.get('year')?.touched && form.get('year')?.invalid">
                <small *ngIf="form.get('year')?.errors?.['required']">Yıl alanı zorunludur.</small>
                <small *ngIf="form.get('year')?.errors?.['pattern']">Yıl 4 haneli bir sayı olmalıdır.</small>
                <small *ngIf="form.get('year')?.errors?.['min']">Yıl 1900'den küçük olamaz.</small>
                <small *ngIf="form.get('year')?.errors?.['max']">Yıl 2100'den büyük olamaz.</small>
            </div>
        </div>

        <div class="mb-3">
            <label for="newEntitledDays" class="form-label">Yeni Hak Edilen Gün</label>
            <input type="number" id="newEntitledDays" class="form-control" formControlName="newEntitledDays" />
            <div class="text-danger"
                *ngIf="form.get('newEntitledDays')?.touched && form.get('newEntitledDays')?.invalid">
                <small *ngIf="form.get('newEntitledDays')?.errors?.['required']">Bu alan zorunludur.</small>
            </div>
        </div>

        <div class="mb-3">
            <label for="carriedOverDays" class="form-label">Önceki Yıldan Kalan Gün</label>
            <input type="number" id="carriedOverDays" class="form-control" formControlName="carriedOverDays"  [readonly]="!data.row"/>
            <div class="text-danger"
                *ngIf="form.get('carriedOverDays')?.touched && form.get('carriedOverDays')?.invalid">
                <small *ngIf="form.get('carriedOverDays')?.errors?.['required']">Bu alan zorunludur.</small>
            </div>
        </div>

        <div class="mb-3">
            <label for="note" class="form-label">Açıklama / Not</label>
            <textarea id="note" rows="3" class="form-control" formControlName="note"></textarea>
            <div class="text-danger" *ngIf="form.get('note')?.touched && form.get('note')?.invalid">
                <small *ngIf="form.get('note')?.errors?.['required']">Açıklama alanı zorunludur.</small>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">İptal</button>
    <button type="button" class="btn btn-primary" (click)="submit()">Kaydet</button>
</div>